import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { ComingSoon } from "@/components/ComingSoon";

export default function Therapeutes() {
  const { locale } = useLang();
  const isFr = locale === "fr";
  return (
    <ComingSoon
      testId="page-therapeutes"
      title={isFr ? "Thérapeutes recommandés" : "Recommended Therapists"}
      blurb={isFr
        ? "À très vite pour découvrir mes recommandations et le réseau de praticiens de confiance que je vous présenterai dans cette section."
        : "See you very soon to discover my recommendations and the network of trusted practitioners I will present in this section."}
    />
  );
}
